import tinymce from "tinymce";

// Required TinyMCE v7 imports
import 'tinymce/themes/silver';
import 'tinymce/models/dom/model';
import 'tinymce/icons/default';
import 'tinymce/plugins/table/plugin';
import 'tinymce/plugins/wordcount/plugin';
import 'tinymce/plugins/autoresize/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/emoticons/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/link/plugin.js';

export function initTinyMCE() {
    tinymce.init({
        autoresize_bottom_margin: 0,
        selector: 'textarea.tinymce-html-editor',
        plugins: 'table lists wordcount',
        height: 300,
        min_height: 150,
        menubar: false,
        toolbar: 'undo redo | blocks fontsize forecolor backcolor | ' +
            'bold italic underline strikethrough removeformat | ' +
            'alignleft aligncenter alignright | ' +
            'indent outdent | bullist numlist | table | emoticons image link',
        skin: false,
        content_css: false,
        base_url: window.location.origin,
        license_key: 'gpl',
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: (cb) => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.addEventListener('change', (e) => {
                const file = e.target.files[0];
                const reader = new FileReader();
                reader.addEventListener('load', () => {
                    const id = 'blobid' + (new Date()).getTime();
                    const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                    const base64 = reader.result.split(',')[1];
                    const blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
                    cb(blobInfo.blobUri(), { title: file.name });
                });
                reader.readAsDataURL(file);
            });

            input.click();
        },
    });
}
